export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_PERIODS_CALL':
            return action.periodList;

        default:
            return state;
    }
};